function t(n){return typeof n=="string"||n instanceof String}export{t as isString};
